export interface Countries {
  name: string;
  code: string;
  flag: string;
}

export const countries: Countries[] = [
  {
    name: "Ireland",
    code: "IE",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1e8-1f1ee.png"
  },
  {
    name: "United Kingdom",
    code: "GB",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1ec-1f1e7.png"
  },
  {
    name: "Australia",
    code: "AU",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1ed-1f1f2.png"
  },
  {
    name: "New Zealand",
    code: "NZ",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1f3-1f1ff.png"
  },
  {
    name: "United States",
    code: "US",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1fa-1f1f8.png"
  },
  {
    name: "Canada",
    code: "CA",
    flag: "https://twemoji.maxcdn.com/v/13.1.0/72x72/1f1e8-1f1e6.png"
  }
];
